import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPlatformOS } from '../utils/platformUtils';

/**
 * V3 路由处理组件
 *
 * 这个组件监听路由变化，当路径包含 /v3/ 时，
 * 会在 HTML 元素上添加 v3-enabled 类，
 * 以便应用特定的 rem 基准值和样式。
 *
 * 同时检测平台类型，为 iOS 平台添加 ios-platform 类，
 * 以便应用 iOS 特定的根字体大小。
 */
export const V3RouteHandler: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // 检查当前路径是否是 v3 路径
    const isV3Route = location.pathname.includes('/v3/');
    const htmlElement = document.documentElement;

    if (isV3Route) {
      // 如果是 v3 路径，添加 v3-enabled 类
      htmlElement.classList.add('v3-enabled');

      // 检测平台类型，为 iOS 平台添加 ios-platform 类
      const platform = getPlatformOS();
      if (platform === 'ios') {
        htmlElement.classList.add('ios-platform');
        console.log('[V3RouteHandler] Added ios-platform class to HTML element');
      } else {
        htmlElement.classList.remove('ios-platform');
      }

      console.log('[V3RouteHandler] Added v3-enabled class to HTML element');
    } else {
      // 如果不是 v3 路径，移除 v3-enabled 类和 ios-platform 类
      htmlElement.classList.remove('v3-enabled');
      htmlElement.classList.remove('ios-platform');
      console.log('[V3RouteHandler] Removed v3-enabled class from HTML element');
    }

    // 触发一次窗口大小变化事件，以便更新 rem 基准值
    if (isV3Route) {
      window.dispatchEvent(new Event('resize'));
    }
  }, [location.pathname]);

  // 这个组件不渲染任何内容
  return null;
};

export default V3RouteHandler;
